module.exports = __webpack_public_path__ + "img/home-icon-4.503456a6.png";